import {
  DEAL_ROOM_SEARCH,
  MATCH_TYPE,
  SearchResultItem,
  SHARED_SECTION,
} from 'models/Search';
import utils, { getBuyingPortfolio, getSellingPortfolio } from 'utils';

export const getDealNavigationUrl = (
  deal: SearchResultItem,
  type: string,
  isSuperAdmin: boolean,
) => {
  const { _id, listingEnquiryId, listing, industry } = deal;

  if (type === DEAL_ROOM_SEARCH.BUYING)
    return getBuyingPortfolio(listingEnquiryId);

  if (type === SHARED_SECTION.MARKETPLACE) {
    if (isSuperAdmin) return getSellingPortfolio(_id);

    return utils.composeBusinessUrl(industry, listing?.slugName, listing?.type);
  }

  return getSellingPortfolio(_id);
};

export const splitDealsByMatchType = (deals: SearchResultItem[]) => {
  const exactDeals: SearchResultItem[] = [];
  const approximateDeals: SearchResultItem[] = [];

  deals.forEach((deal) =>
    (deal.matchType === MATCH_TYPE.APPROXIMATE
      ? approximateDeals
      : exactDeals
    ).push(deal),
  );

  return { exactDeals, approximateDeals };
};
